<div class="maintenance-bg min-h-screen flex items-center justify-center px-4 py-8">
    <div class="maintenance-card w-full max-w-md text-center">

        <img src="assets/images/oldelval-go-logo.png" alt="Logo Oldelval" class="logo mx-auto mb-8" />

        <div class="icon-wrapper mx-auto mb-6">
            <i class="pi pi-cog pi-spin"></i>
        </div>

        <h1 class="title mb-4">Estamos actualizando la plataforma</h1>

        <p class="message mb-8">{{ message }}</p>

        <p class="foot-note">© {{ currentYear }} OLDELVAL</p>
    </div>
</div>
